module.exports = __webpack_public_path__ + "img/payback.08a9107d.svg";